import { MutableRefObject, Ref } from 'react';

// Taken from https://github.com/NadavCohen/react-fork-ref
export function forkRef<T>(...refs: Ref<T>[]) {
  return function (node: T | null) {
    for (const ref of refs) {
      if (typeof ref === 'function') ref(node);
      else if (ref) (ref as MutableRefObject<T | null>).current = node;
    }
  };
}
